<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				图书信息: <span v-if="book!=null" class="red">
					{{ book.BooksName +' '+ book.WriterName +' '+ book.WriterBooksReferences }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍编号:{{book.BooksNumCode}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍分类:{{book.Classification1 }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍归属:{{book.BelongTo}}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>移动前</th>
							<th>移动后</th>
							<th>当前位置</th>
							<th>操作备注</th>
							<th>操作人</th>
							<th>操作时间</th>
							 
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in history">
							<td>{{index+1}}</td>
							<td>
								{{i.oldShopName}}
							</td>
							<td  >
								{{i.ShopName}}
							</td>
							
							 <td>
							 	{{i.IsCurrentPlace}}
							 </td>
							 <td>
							 	{{i.BooksDesc}}
							 </td>
							 <td>
							 	{{i.UserName}}
							 </td>
							 <td>
							 	{{i.OperationTime}}
							 </td>
						</tr>

					</tbody>
				</table>

			</div>
			
		</div>
<div class="foot_pages">
				<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
				<span>{{page}}</span>

				<select v-model="pageRows" @change="changePageRows">
					<option value="10">10/页</option>
					<option value="15">15/页</option>
					<option value="20">20/页</option>
					<option value="25">25/页</option>
					<option value="30">30/页</option>

				</select>
				<button class="button" :class="{'disabled':down}" :disabled="down"
					@click="changePages('down')">下一页</button>
			</div>
	</div>





</template>

<script>
	import j from './queryBookMoveHistory.js'
	export default j
</script>

<style>
</style>
